import { createShaderMaterial } from './ShaderUtils';
import THREE from "three";

export class ShaderPass {
  renderToScreen = false;
  enabled = true;
  clear = false;

  constructor(shader, textureID) {
    this._shader = shader;
    this._textureID = textureID;

    this.textureID = this._textureID !== undefined ? this._textureID : 'tDiffuse';

    this.material = createShaderMaterial(this._shader);

    // share uniforms with material
    this.uniforms = this.material.uniforms;


    this.camera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);

    //this.quad = new THREE.Mesh( new THREE.PlaneGeometry( 2, 2 ), this.material );

    //Instead of using a screen quad we use a large triangle -- this is slightly
    //faster (~6% measured in our specific case), due to better cache coherency. See this article:
    //http://michaldrobot.com/2014/04/01/gcn-execution-patterns-in-full-screen-passes/
    this._triangle = new THREE.BufferGeometry();
    this._p = new Float32Array([-1, -1, 0, 3, -1, 0, -1, 3, 0]);

    this._uv = new Float32Array([0, 0, 2, 0, 0, 2]);

    const n = new Float32Array([0, 0, 1, 0, 0, 1, 0, 0, 1]);

    this._triangle.setAttribute("position", new THREE.BufferAttribute(this._p, 3));
    this._triangle.setAttribute("normal", new THREE.BufferAttribute(n, 3));
    this._triangle.setAttribute("uv", new THREE.BufferAttribute(this._uv, 2));

    this.quad = new THREE.Mesh(this._triangle, this.material);

    this.scene = new THREE.Scene();
    this.scene.add(this.quad);
  }

  render(renderer, writeBuffer, readBuffer, delta) {

    if (this.uniforms[this.textureID]) {
      // Note: As long as we use the LMV WebGLRenderer that is based on old THREE, __webGLTexture is
      //       attached to the target itself. As long as that's the case, we have to set readBuffer here,
      //       not readBuffer.texture.
      this.uniforms[this.textureID].value = readBuffer;
    }

    renderer.setRenderTarget(writeBuffer);
    if (!this.renderToScreen && this.clear) {
      renderer.clear();
    }

    renderer.render(this.scene, this.camera);
  }
}